import React, { useEffect, useMemo, useRef } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { useMarkDialogAsSeen } from '../../../services/use-mark-dialog-as-seen';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './entrypoint';

export function FeatureOnboardingModal() {
	const { hasDialogAutoOpened } = useEditionAwareness();
	const modalProps = useMemo(() => ({ width: 968, height: 568, autoFocus: false }), []);

	const shouldAutoOpen = useMemo(
		() => !hasDialogAutoOpened('feature-onboarding'),
		[hasDialogAutoOpened],
	);
	const markDialogAsSeen = useMarkDialogAsSeen();

	const hasMarked = useRef(false);

	useEffect(() => {
		if (hasMarked.current || !shouldAutoOpen) {
			return;
		}
		markDialogAsSeen('feature-onboarding');
		hasMarked.current = true;
	}, [shouldAutoOpen, markDialogAsSeen]);

	const entryPointProps = useMemo(() => ({ isAutoOpened: shouldAutoOpen }), [shouldAutoOpen]);

	return (
		<ModalEntryPoint
			entryPoint={entryPoint}
			modalProps={modalProps}
			dialogConfig={DIALOG_CONFIG}
			entryPointProps={entryPointProps}
			shouldAutoOpen={shouldAutoOpen}
		/>
	);
}
